import { render, staticRenderFns } from "./orderActionDialog.vue?vue&type=template&id=2b6f0430&"
import script from "./orderActionDialog.vue?vue&type=script&lang=js&"
export * from "./orderActionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports